<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
              <Form-item label="剧名" prop="title">
                <Input type="text" v-model="searchForm.title" placeholder="请输入剧名" clearable style="width: 200px"/>
              </Form-item>
              <!-- <Form-item label="所属公司" prop="title">
                <Input type="text" v-model="searchForm.title" placeholder="请输入所属公司" clearable style="width: 200px"/>
              </Form-item> -->
              <Form-item label="类型" prop="copyrightType">
                  <Select v-model="searchForm.copyrightType" placeholder="请选择" clearable style="width: 200px">
                        <Option v-for="(item, i) in copyrightCategory" :key="i" :value="item.value">
                        {{item.title}}</Option>
                    </Select>
                <!-- <Input type="text" v-model="searchForm.copyrightType" placeholder="请输入所属类型" clearable style="width: 200px"/> -->
              </Form-item>
                <Form-item label="上映时间" prop="releaseDate">
                  <DatePicker type="year" v-model="searchForm.releaseDate" style="width:100%" placeholder="请选择" @on-change='changeTime'></DatePicker>
                </Form-item>
                <Form-item label="授权情况" prop="copyrightAuthType">
                  <Select v-model="searchForm.copyrightAuthType" placeholder="请选择" clearable style="width: 200px">
                    <Option v-for="(item, i) in copyrightStatus" :key="i" :value="item.value">
                    {{item.title}}</Option>
                  </Select>
              </Form-item>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
              </Form-item>
            </Form>
          </Row>
          <Row class="operation">
            <Button @click="add" type="primary" icon="md-add">添加</Button>
            <Button @click="delAll" icon="md-trash">批量删除</Button>
            <Button @click="getCopyrightManageList" icon="md-refresh">刷新</Button>
          </Row>
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="dataList" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >        
        <FormItem label="公司名称" prop="copyrightVendorId" >
            <Select v-model="form.copyrightVendorId" placeholder="请选择" clearable style="width: 200px">
                <Option v-for="(item, i) in allCopyrightVendorList" :key="i" :value="item.id">
                {{item.copyrightVendorName}}</Option>
            </Select>
          <!-- <Input v-model="form.copyrightName" style="width:100%"/> -->
        </FormItem>
         <FormItem label="合作开始时间" prop="copyrightStartTime" >
            <DatePicker type="date" v-model="form.copyrightStartTime" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="合作时长" prop="cooperationPeriod" >
           <Select v-model="form.cooperationPeriod" placeholder="请选择" clearable style="width: 200px">
              <Option v-for="(item, i) in dictTime" :key="i" :value="item.value">{{item.title}}</Option>
            </Select>
        </FormItem>
        <!-- <FormItem label="分润比例" prop="shareProfitRatio" >
          <Input v-model="form.shareProfitRatio" style="width:100%"/>
        </FormItem>
        <FormItem label="联系人" prop="linkman" >
          <Input v-model="form.linkman" style="width:100%"/>
        </FormItem>
        <FormItem label="联系人手机号" prop="linkmanTel" >
          <Input v-model="form.linkmanTel" style="width:100%"/>
        </FormItem> -->
        <FormItem label="文件上传控件" prop="totalIncome" >
          <!-- <Input v-model="form.totalIncome" style="width:100%"/> -->
          <input id="fileupload" type="file"  name="file" accept=".xlsx,.xls" @change="uploadFile">
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>
      </div>
    </Modal>
    <Modal :title="modalTitle" v-model="modalUpdataVisible" :mask-closable='false' :width="500">
      <Form ref="formUpdata" :model="formUpdata" :label-width="100">        
        <FormItem label="片名" prop="title" >
          <Input v-model="formUpdata.title" style="width:100%" placeholder="请输入片名"/>
        </FormItem>
         <FormItem label="类型" prop="copyrightType" >
            <Select v-model="formUpdata.copyrightType" placeholder="请选择" clearable style="width: 200px">
                <Option v-for="(item, i) in copyrightCategory" :key="i" :value="item.value">
                {{item.title}}</Option>
            </Select>
        </FormItem>
        <FormItem label="导演" prop="director" >
           <Input v-model="formUpdata.director" style="width:100%" placeholder="请输入导演"/>
        </FormItem>
        <FormItem label="主演集合" prop="mainStar" >
          <Input v-model="formUpdata.mainStar" style="width:100%" placeholder="请输入主演"/>
        </FormItem>
        <FormItem label="上映时间" prop="releaseDate" >
          <DatePicker type="date" v-model="formUpdata.releaseDate" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="剧情简介" prop="summary" >
          <Input v-model="formUpdata.summary" style="width:100%" placeholder="请输入剧情简介"/>
        </FormItem>
        <FormItem label="集数" prop="episodeNum" >
          <Input v-model="formUpdata.episodeNum" style="width:100%" placeholder="请输入集数"/>
        </FormItem>
        <FormItem label="时长" prop="duration" >
          <Input v-model="formUpdata.duration" style="width:100%" placeholder="请输入时长"/>
          <!-- <Select v-model="formUpdata.cooperationPeriod" placeholder="请选择" clearable style="width: 200px">
            <Option v-for="(item, i) in dictTime" :key="i" :value="item.value">{{item.title}}</Option>
          </Select> -->
        </FormItem>
        <FormItem label="版权授权类型" prop="copyrightAuthType" >
          <Select v-model="formUpdata.copyrightAuthType" placeholder="请选择" clearable style="width: 200px">
              <Option v-for="(item, i) in copyrightAuthType" :key="i" :value="item.value">
                {{item.title}}</Option>
            </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalUpdataVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="updateSubmit">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>

import {getAllcopyrightVendorList,copyrightManageList,copyrightManageAdd,copyrightManageDelect,copyrightManageEdit} from "@/api/index";
export default {
  name: "copyright_vendor_detail",
  components: {
  },
  data() {
    return {
      titleInfo:"",
      dataList:[],
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalUpdataVisible:false,
      modalTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        // sort: "createTime", // 默认排序字段
        // order: "desc", // 默认排序方式
        title:"",
        copyrightType:"",
        releaseDate:"",
        copyrightAuthType:''
      },
      copyrightAuthType:this.$store.state.dict.copyrightAuthType,// 版权授权类型
      selectDate: null,
      form: { // 添加或编辑表单对象初始化数据
        copyrightVendorId: "",
        copyrightStartTime: "",
        cooperationPeriod: "",
        // linkman: "",
        // linkmanTel: "",
        importFile:""
      },
      formUpdata:{
          title:"",
          copyrightType:"",
          director:"",
          mainStar:"",
          releaseDate:"",
          summary:"",
          episodeNum:"",
          duration:"",
          copyrightAuthType:""
      },
      updataId:"",
      // 表单验证规则
      formValidate: {
      },
      dictTime:this.$store.state.dict.cooperationDurationType,
      copyrightCategory:this.$store.state.dict.copyrightCategory,//类型  版权分类
      copyrightStatus:this.$store.state.dict.copyrightStatus,
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "剧名",
          key: "title",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "类型",
          key: "copyrightType",
          minWidth: 120,
          sortable: false,
          render: (h, params) => {
            if (params.row.copyrightType == 'ip_movie') {
              return h("div", [
                h(
                  "span",
                    "电影"
                  )
              ]);
            }else if(params.row.copyrightType == 'ip_tv'){
              return h("div", [
                h(
                  "span",
                    "电视"
                  )
              ]);
            }else if(params.row.copyrightType == 'ip_variety_show'){
              return h("div", [
                h(
                  "span",
                    "综艺"
                  )
              ]);
            }else if(params.row.copyrightType == 'ip_cartoon'){
              return h("div", [
                h(
                  "span",
                    "动画"
                  )
              ]);
            }else if(params.row.copyrightType == 'ip_vlog'){
              return h("div", [
                h(
                  "span",
                    "短视频"
                  )
              ]);
            }else if(params.row.copyrightType == 'ip_documentary_film'){
              return h("div", [
                h(
                  "span",
                    "纪录片"
                  )
              ]);
            }else if(params.row.copyrightType == 'ip_esports'){
              return h("div", [
                h(
                  "span",
                    "电竞"
                  )
              ]);
            }else if(params.row.copyrightType == 'ip_sports'){
              return h("div", [
                h(
                  "span",
                    "体育"
                  )
              ]);
            }else if(params.row.copyrightType == 'ip_other'){
              return h("div", [
                h(
                  "span",
                    "其他"
                  )
              ]);
            }
          }
        },
        {
          title: "集数",
          key: "episodeNum",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "分钟",
          key: "duration",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "上映时间",
          key: "releaseDate",
          minWidth: 120,
          sortable: true,
          render: (h, params) => {
            if (params.row.releaseDate == null) {
              return h("div", [
                h(
                  "span",
                    '-'
                  )
              ]);
            }else{
              return h("div", [
                h(
                  "span",
                    params.row.releaseDate.substring(0,4)
                  )
              ]);
            }
          }
        },
        {
          title: "是否已转授权运营",
          key: "copyrightStatus",
          minWidth: 120,
          sortable: false,
          render: (h, params) => {
            if (params.row.copyrightStatus == '1') {
              return h("div", [
                h(
                  "span",
                    "已授权运营"
                  )
              ]);
            }else if(params.row.copyrightStatus == '0'){
              return h("div", [
                h(
                  "span",
                    "未授权运营"
                  )
              ]);
            }
          }
        },
        {
          title: "拥有权利",
          key: "copyrightAuthType",
          minWidth: 120,
          sortable: false,render: (h, params) => {
            if (params.row.copyrightAuthType == 'ip_auth_exclusive') {
              return h("div", [
                h(
                  "span",
                    "独家"
                  )
              ]);
            }else if(params.row.copyrightAuthType == 'ip_auth_not_exclusive'){
              return h("div", [
                h(
                  "span",
                    "非独家"
                  )
              ]);
            }else if(params.row.copyrightAuthType == 'ip_auth_public'){
              return h("div", [
                h(
                  "span",
                    "公版"
                  )
              ]);
            }else if(params.row.copyrightAuthType == 'ip_auth_exclusive_list'){
              return h("div", [
                h(
                  "span",
                    "排他"
                  )
              ]);
            }
          }
        },
        // {
        //   title: "",
        //   key: "remarks",
        //   minWidth: 120,
        //   sortable: false,
        // },
        {
          title: "操作",
          key: "action",
          align: "center",
          width:400,
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-create-outline"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.edit(params.row);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-search"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.sendDetail(params.row);
                    }
                  }
                },
                "查看详情"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    icon: "md-trash"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row);
                    }
                  }
                },
                "删除"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "warning",
                    size: "small",
                    icon: "md-add"
                  },
                  on: {
                    click: () => {
                      this.addMonitor(params.row);
                    }
                  }
                },
                "添加到监测任务"
              )
            ]);
          }
        }
      ],
      data: [], // 表单数据
      total: 0 ,// 表单数据总数
      allCopyrightVendorList:[]
    };
  },
  methods: {
    init() {
      this.getCopyrightManageList()
      this.getAllcopyrightVendorList()
    },
    changeTime(e){
      this.searchForm.releaseDate = e
    },
    getAllcopyrightVendorList(){
      getAllcopyrightVendorList().then(res=>{
        if(res.success){
          this.allCopyrightVendorList = res.result
        }
      })
    },
    addMonitor(v){
      let query = { id: v.id ,name:v.title};
      this.$router.push({
        name: "monitor-copyright-task-manage",//详情页面
        query: query
      });
    },
    uploadFile(event){
      console.log(event.target.files[0].size)
      let maxSize = 1024 * 1024 * 2
      if(event.target.files[0].size > maxSize){
        alert('上传文件过大！最大只能上传2M的文件')
        return false
      }
      this.form.importFile = event.target.files[0]
    },
    sendDetail(v) {
      let query = { id: v.id,name:v.title};
      this.$router.push({
        name: "copyright_manage_detail",//详情页面
        query: query
      });
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getCopyrightManageList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getCopyrightManageList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getCopyrightManageList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.selectDate = null;
      this.searchForm.releaseDate = "";
      // 重新加载数据
      this.getCopyrightManageList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getCopyrightManageList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.releaseDate = v[0];
        this.searchForm.cooperationEndTime = v[1];
      }
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    //获取版权管理列表
    getCopyrightManageList(){
      copyrightManageList(this.searchForm).then(res=>{
        if(res.success){
          this.dataList = res.result.records;
          this.total = res.result.total;
        }
        // this.total = this.dataList.length;
        this.loading = false;
      })
    },
    //编辑提交
    updateSubmit(){
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          if(this.formUpdata.releaseDate != ""){
            var d = new Date(this.formUpdata.releaseDate);
            var resDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
            this.formUpdata.releaseDate = resDate
          }
          let data = {
              id:this.updataId,
              title:this.formUpdata.title,
              copyrightType:this.formUpdata.copyrightType,
              director:this.formUpdata.director,
              mainStar:this.formUpdata.mainStar,
              releaseDate:this.formUpdata.releaseDate,
              summary:this.formUpdata.summary,
              episodeNum:this.formUpdata.episodeNum,
              duration:this.formUpdata.duration,
              copyrightAuthType:this.formUpdata.copyrightAuthType
          }
          copyrightManageEdit(data).then(res=>{
            this.submitLoading = false;
            if(res.success){
              this.$Message.success("修改成功");
              this.getCopyrightManageList();
              this.modalUpdataVisible = false;
            }
          })
        }
      })
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          if (this.modalType === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            if(this.form.copyrightStartTime != ""){
              var d = new Date(this.form.copyrightStartTime);
              var resDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
              this.form.copyrightStartTime = resDate
            }
            let formData = new FormData()
            formData.append("importFile",this.form.importFile)
            formData.append("copyrightVendorId",this.form.copyrightVendorId)
            formData.append("copyrightStartTime",this.form.copyrightStartTime)
            formData.append("cooperationPeriod",this.form.cooperationPeriod)
            // formData.append("linkman",this.form.linkman)
            // formData.append("linkmanTel",this.form.linkmanTel)
            // if(formData.get("importFile") != ''){
              copyrightManageAdd(formData).then(res => {
                this.submitLoading = false;
                if (res.success) {
                  this.$Message.success("操作成功");
                  this.getCopyrightManageList();
                  this.modalVisible = false;
                }
              });
            // }
            
            // 模拟请求成功
            // this.submitLoading = false;
            // this.$Message.success("操作成功");
            // this.modalVisible = false;
          } else {
            // 编辑
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getCopyrightManageList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getCopyrightManageList();
            this.modalVisible = false;
          }
        }
      });
    },
    add() {
      this.modalType = 0;
      this.modalTitle = "添加";
      this.$refs.form.resetFields();
      delete this.form.id;
      this.modalVisible = true;
    },
    edit(v) {
      this.modalType = 1;
      this.modalTitle = "编辑";
      this.updataId = v.id;
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.formUpdata = data;
      this.modalUpdataVisible = true;
    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.title + " ?",
        loading: true,
        onOk: () => {
          // 删除
          copyrightManageDelect(v.id).then(res => {
            this.$Modal.remove();
            if (res.success) {
              this.$Message.success("操作成功");
              this.getCopyrightManageList();
            }
          });
          // 模拟请求成功
          // this.$Message.success("操作成功");
          // this.$Modal.remove();
          // this.getCopyrightManageList();
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          copyrightManageDelect(ids).then(res => {
            this.$Modal.remove();
            if (res.success) {
              this.$Message.success("操作成功");
              this.clearSelectAll();
              this.getCopyrightManageList();
            }
          });
          // 模拟请求成功
          // this.$Message.success("操作成功");
          // this.$Modal.remove();
          // this.clearSelectAll();
          // this.getCopyrightManageList();
        }
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
</style>